module.exports = __webpack_public_path__ + "img/kuaishou2s.e03703f1.png";